import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { format } from 'date-fns';
import React from 'react';
import { Link } from 'react-router-dom';

interface Referral {
  id: number;
  name: string;
  status: string;
  date: Date;
}

const defaultData: Referral[] = [
  {
    id: 1,
    name: 'Anika Carder',
    status: 'Complete',
    date: new Date(),
  },
  {
    id: 2,
    name: 'Gina Westervelt',
    status: 'Complete',
    date: new Date(),
  },
];

const columnHelper = createColumnHelper<Referral>();

const columns = [
  columnHelper.accessor('name', {
    id: 'name',
    header: () => 'Name',
    cell: (info) => (
      <Link className='font-bold text-primary' to={`#`}>
        {info.renderValue()}
      </Link>
    ),
  }),
  columnHelper.accessor('status', {
    header: 'Status',
    cell: (info) => (
      <div
        className={
          'inline-flex rounded-full bg-[#AFC12D] px-3 py-1 text-sm hover:bg-opacity-90'
        }
      >
        {info.renderValue()}
      </div>
    ),
  }),
  columnHelper.accessor('date', {
    header: 'Date',
    cell: (info) => format(info.row.original.date, 'MM/dd/yy'),
  }),
];

const Referrals = () => {
  const [data, setData] = React.useState(() => [...defaultData]);
  const [globalFilter, setGlobalFilter] = React.useState('');
  const [pageSize, setPageSize] = React.useState(50);
  const rerender = React.useReducer(() => ({}), {})[1];

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <>
      <table className='datatable-table datatable-one w-full table-auto border-collapse overflow-hidden break-words px-4 md:table-fixed md:overflow-auto md:px-8'>
        <thead className='border-separate px-4'>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr
              className='border-t border-stroke bg-whiten'
              style={{ fontSize: '14px' }}
              key={headerGroup.id}
            >
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  style={{ paddingTop: '16px', paddingBottom: '16px' }}
                >
                  <div className='flex items-center'>
                    <span>
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                    </span>
                    <div className='ml-2 inline-flex flex-col space-y-[2px]'>
                      <span className='inline-block'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='17'
                          height='16'
                          viewBox='0 0 17 16'
                          fill='none'
                        >
                          <path
                            d='M8.5 14.6666L4.5 10.6666L5.45 9.71659L8.5 12.7666L11.55 9.71659L12.5 10.6666L8.5 14.6666ZM5.46667 6.26659L4.5 5.33325L8.5 1.33325L12.5 5.33325L11.5333 6.26659L8.5 3.23325L5.46667 6.26659Z'
                            fill='#131212'
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr className='border-t border-stroke' key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <td
                  style={{ paddingTop: '16px', paddingBottom: '16px' }}
                  key={cell.id}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      <div className='flex justify-between border-t border-stroke px-8 pt-5'>
        <p className='font-light'>Showing {data.length} results</p>
        <div className='flex'>
          <button className='flex cursor-pointer items-center justify-center rounded-md p-1 px-2 hover:bg-primary'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 18 18'
              fill='none'
            >
              <path
                d='M12.1433 16.5L4.5 9L12.1433 1.5L13.5 2.83125L7.21338 9L13.5 15.1688L12.1433 16.5Z'
                fill='#131212'
              />
            </svg>
          </button>

          <button className='mx-1 flex cursor-pointer items-center justify-center rounded-md bg-primary p-1 px-3 hover:bg-primary'>
            1
          </button>
          <button className='mx-1 flex cursor-pointer items-center justify-center rounded-md p-1 px-3 hover:bg-primary'>
            2
          </button>
          <button className='mx-1 flex cursor-pointer items-center justify-center rounded-md p-1 px-3 hover:bg-primary'>
            3
          </button>

          <button className='flex cursor-pointer items-center justify-center rounded-md p-1 px-2 hover:bg-primary'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 18 18'
              fill='none'
            >
              <path
                d='M5.85669 16.5L4.5 15.1688L10.7866 9L4.5 2.83125L5.85669 1.5L13.5 9L5.85669 16.5Z'
                fill='#131212'
              />
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};

export default Referrals;
